import { render } from "./cardOrder.vue?vue&type=template&id=2b269068"
import script from "./cardOrder.vue?vue&type=script&lang=js"
export * from "./cardOrder.vue?vue&type=script&lang=js"

import "./cardOrder.vue?vue&type=style&index=0&id=2b269068&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__